import { HTTP } from './http-common'

export { getConfig }

export const appConfig = {
    backendUrl: '/portal',
    clientsPortalURL: '',
    adminPortalURL: '',
    clientId: '',
    authorizeURL: '',
    logoutURL: '',
    redirectURL: '',
}

function getConfig () {
    const url = `/all/getconfig`
    const params = {}
    return HTTP.get(url, {
        params,
    }).then(
      response => {
          return response.data
      },
    ).catch(error => {
        console.log(error)
        throw error
    })
}
